<template>
  <div class="device_tarififcation" v-if="Object.keys(tariffication_list).length > 0">
    <div
        v-for="(t_item, key) in tariffication_list"
        :key="key"
        class="card tariff_card"
    >
      <div class="tariff_header">
        <div>
          <router-link class="title" :to="'/tariff/' + t_item.tariffication_data.tariff_id">
            {{ get_tariff_header(t_item)}}
          </router-link>
        </div>

        <div class="text-right" v-if="key === 0">
          <router-link class="btn btn-success btn-fill btn-wd" :to="{path: '/tariffication/tariffed_devices?fid=' + dev_fid}">
            {{ translate("traffic_packet_list.tariff_packet_item.tariff management") }}
          </router-link>
        </div>
      </div>

      <div v-for="(packets_by_date, date) in t_item.packets" :key="date" class="card packet_card">
        <div class="row">
          <div class="col-md-6">
            <p class="packet_header">
              {{ date }}
              {{ get_cost_month_info(packets_by_date) }}
            </p>
            <p class="packet_header">
              {{ get_traffic_month_info(packets_by_date) }}
            </p>
          </div>
          <div class="col-md-6" v-if="$store.getters.getPermissions.buyTrafficPackets === true">
            <div class="text-right" v-if="packets_by_date.can_buy_packet === true">
              <button class="btn btn-success btn-fill btn-wd"
                @click="add_new_packet(t_item.tariffication_data, t_item.tariffication_data.id)">
                {{ translate("traffic_packet_list.tariff_packet_item.add_new_packet") }}
              </button>
            </div>
          </div>
        </div>
        <div class="response_table" v-if="!packets_by_date.empty_table">
          <table>
            <thead>
              <tr>
                <th scope="col"> {{ translate('traffic_packet_list.tariff_packet_item.name') }} </th>
                <th scope="col"> {{ translate('traffic_packet_list.tariff_packet_item.period_of_use') }}</th>
                <th scope="col"> {{ translate('traffic_packet_list.tariff_packet_item.cost') }}</th>
                <th scope="col"> {{ translate('traffic_packet_list.tariff_packet_item.traffic_status') }}</th>
                <th scope="col"> {{ translate('traffic_packet_list.tariff_packet_item.date_end') }}</th>
                <th scope="col" v-if="$store.getters.getPermissions?.permissionGod === true"> Details </th>
              </tr>
            </thead>
            <tbody>
              <tr
                  v-for="(item, key_item) in packets_by_date.data.slice().reverse()"
                  :key="key_item"
                  :class="{ active_item: item.status > 0, over_item: item.is_over, suspense: item.suspense > 0 }"
                  v-if="item.id !== null"
              >
                <td :data-label="translate('traffic_packet_list.tariff_packet_item.name')" >
                  {{ item.tariff_packet_name }}
                </td>
                <td :data-label="translate('traffic_packet_list.tariff_packet_item.period_of_use')" >
                  {{ item.period_start }} - {{ item.period_end ? item.period_end : "по н.в." }}
                </td>
                <td :data-label="translate('traffic_packet_list.tariff_packet_item.cost')" >
                  {{ item.cost }}
                </td>
                <td :data-label="translate('traffic_packet_list.tariff_packet_item.traffic_status')" >
                  {{ item.traffic_status }}
                </td>
                <td :data-label="translate('traffic_packet_list.tariff_packet_item.traffic_status')" >
                  <span v-if="item?.status === 0 && item?.ts_end > 0">
                    {{ item.time_end }}
                  </span>
                </td>
                <td data-label="Details" v-if="$store.getters.getPermissions?.permissionGod === true">
                  <button class="btn-info btn-fill btn-wd marginButton"
                    @click="show_packet_info(item.id)">
                    {{ translate("traffic_packet_list.tariff_packet_item.packet_info") }}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
  <div v-else style="height: 100%">
    <div v-if="load">
      <scale-loader />
    </div>
    <h1 v-else style="text-align: center" >
      {{translate('no_data')}}
    </h1>
  </div>
</template>

<script>

import TariffPacketItem from "@/views/Dashboard/General/TrafficPacketList/Tabs/DevicePacketItems/DevicePacketItemsModal/Index.vue";
import BuyTariffPacketItem from "./Modal/BuyTariffPacketItem.vue";

export default {
  name: 'DeviceTariffication',
  components: {},
  props: ['dev_fid'],

  data() {
    return {
      tariffication_list: [],
      load: false,
      options: {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      },
    }
  },
  created() {
    this.get_tariffication_info()
  },
  methods: {
    get_traffic_month_info(items) {
      let traffic_limit = 0, traffic_used = 0;
      items.data.forEach((item) => {
        if (item.id !== null) {
          traffic_limit += item.traffic_limit
          traffic_used += item.traffic_used
        }
      })
      if (traffic_limit > 0) {
        return " Трафик (Остаток " + (traffic_limit - traffic_used) + " из " + traffic_limit + " Mb)";
      }
      return ""
    },
    get_cost_month_info(items) {
      let cost_currency = {
        RUB: -1,
        USD: -1,
        EUR: -1
      }

      items.data.forEach((item) => {
        let cost = item.cost.split(' ')
        if (cost_currency[cost[1]] === -1) cost_currency[cost[1]] = 0
        cost_currency[cost[1]] += parseFloat(cost[0])
      })
      let result = "Стоимость: ";

      Object.keys(cost_currency).forEach((cur) => {
        if (cost_currency[cur] > -1) {
          result += " " + (cost_currency[cur]) + " (" + cur + ")"
        }
      })

      return result;
    },
    get_tariff_header(t_item) {
      let header = ""
      if (t_item.tariffication_data.date_end !== null){
        header = `Тарифицировался по тарифу ${t_item.tariffication_data.tariff_name} c ${t_item.tariffication_data.date_start} по ${t_item.tariffication_data.date_end}`
      } else {
        header = `Тарифицируется по тарифу ${t_item.tariffication_data.tariff_name} `
      }
      return header
    },
    get_tariffication_info() {
      this.load = true
      this.$http.v1.getDeviceTarifficationPackets(this.dev_fid, (response) => {
        this.load = false
        this.tariffication_list = response.data
      })
    },
    add_new_packet(info, tariffication_id) {
      if (!tariffication_id) return
      let t = this.$createElement(BuyTariffPacketItem, {
        props: {
          tariffication_info: info,
          tariffication_id: tariffication_id
        },
        on: {
          close: () => {
            this.$modal.hide('buy_packet_item')
          },
          update: () => {
            this.get_tariffication_info()
            this.$modal.hide('buy_packet_item')
          }
        }
      })
      let temp = {
        render() {
          return t
        }
      }
      this.$modal.show(temp, {}, {
        height: "auto",
        width: 800, //TODO in const to
        adaptive: true,
        clickToClose: true,
        name: 'buy_packet_item'
      })
    },

    show_packet_info(tariff_packet_item_id) {
      if (!tariff_packet_item_id) return
      let t = this.$createElement(TariffPacketItem, {
        props: {
          tariff_packet_item_id
        },
        on: {
          close: () => {
            this.$modal.hide('tariff_packet_item')
          },
          update: () => {
            this.$emit("update", this.send_filter)
          }
        }
      })
      let temp = {
        render() {
          return t
        }
      }
      this.$modal.show(temp, {}, {
        height: 700,
        width: 800, //TODO in const to
        adaptive: true,
        clickToClose: true,
        name: 'tariff_packet_item'
      })
    },
  }

}
</script>

<style lang="scss" scoped>
.device_tarififcation {
  height: 100%;
  .card{
    .tariff_header{
      padding-bottom: 15px;
      display: flex;
      justify-content: space-between;
      align-items: baseline;
      .title{
        font-size: 18px;
        font-weight: bold;
      }
    }
    .packet_header{
      font-size: 18px;
      font-weight: bold;
      margin-bottom: 0;
    }
    .response_table{
      margin-top: 10px;
    }
  }
  .tariff_card{
    padding: 15px;
    margin-bottom: 10px;
  }
  .packet_card{
    padding: 10px;
    margin-bottom: 10px;
    .response_table{
      padding: 0;
    }

    .active_item {
      background-color: #41b88330;
    }

    .over_item {
      background-color: #ebcb6230;
    }

    .suspense{
      background-color: #68B3C830;
    }
  }
}
</style>
